const RANKING = [
  { rank: 1, title: '反派千金的生存法则', type: '韩漫·奇幻', heat: '9.9', trend: 'up' },
  { rank: 2, title: '剑术名家的独女', type: '韩漫·恋爱', heat: '9.8', trend: 'up' },
  { rank: 3, title: '咒术回战', type: '日漫·热血', heat: '9.7', trend: 'stable' },
  { rank: 4, title: '某天成为公主', type: '韩漫·奇幻', heat: '9.6', trend: 'up' },
  { rank: 5, title: '一人之下', type: '国漫·奇幻', heat: '9.5', trend: 'up' },
  { rank: 6, title: '间谍过家家', type: '日漫·搞笑', heat: '9.4', trend: 'stable' },
  { rank: 7, title: '镖人', type: '国漫·热血', heat: '9.3', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            人气排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            实时更新的热门漫画人气榜单，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-[720px] mx-auto">
          {RANKING.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-4 md:px-5 py-3.5 border-b border-background-200/50 last:border-none hover:bg-background-100/80 transition-colors rounded-lg cursor-default"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-800 truncate">{item.title}</div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.type}</div>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                <span className="text-sm font-heading font-bold text-primary-500">{item.heat}</span>
                <span className="text-xs text-foreground-400">分</span>
                {item.trend === 'up' && (
                  <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                )}
                {item.trend === 'stable' && (
                  <i className="ri-subtract-line text-foreground-400 text-sm"></i>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}